/* THE TOTELAND — scripts propios (prefijo mt-) */
(function () {
  'use strict';

  function safe(fn, label) {
    try { fn(); } catch (e) { console.warn('[Toteland] ' + label + ' failed:', e); }
  }

  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;
    items.forEach(function (el) {
      var delay = el.getAttribute('data-delay');
      if (delay) el.style.setProperty('--mt-stagger', delay + 'ms');
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      items.forEach(function (el) { observer.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
    }
    setTimeout(function () {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
    }, 6000);
  }

  /* -----------------------------------------------------------------------
     RESEÑAS — el contenido se renderiza server-side desde los bloques de la
     sección (editable en el editor de temas), no hay envío público: solo
     controla el botón "ver más" que revela las reseñas que exceden el
     límite configurado (setting "reviews_visible").
     --------------------------------------------------------------------- */
  function initResenas() {
    document.querySelectorAll('[data-mt-resenas-root]').forEach(function (root) {
      var moreBtn = root.querySelector('[data-mt-reviews-more]');
      if (!moreBtn) return;
      moreBtn.addEventListener('click', function () {
        root.querySelectorAll('.mt-review-card--hidden').forEach(function (card) {
          card.classList.remove('mt-review-card--hidden');
        });
        moreBtn.closest('.mt-reviews-more-wrap').remove();
      });
    });
  }

  /* -----------------------------------------------------------------------
     PÁGINA DE PRODUCTO — swatches/pills de opción, precio dinámico, miniaturas
     --------------------------------------------------------------------- */
  function mtFormatMoney(cents, format) {
    // Respeta el formato de moneda de la tienda si se expuso globalmente;
    // si no, hace un formateo simple en centavos -> unidades con 2 decimales.
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && Shopify.formatMoney && format) {
      try { return Shopify.formatMoney(cents, format); } catch (e) {}
    }
    return '$' + amount;
  }

  function initProducto() {
    var form = document.getElementById('mt-producto-form');
    if (!form) return;
    var variantsScript = form.querySelector('[data-mt-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var variantIdInput = form.querySelector('[data-mt-variant-id]');
    var priceEl = document.querySelector('[data-mt-price]');
    var comparePriceEl = document.querySelector('[data-mt-compare-price]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var addText = form.querySelector('[data-mt-add-text]');
    var moneyFormat = window.mtMoneyFormat || null;

    var selections = {};
    form.querySelectorAll('[data-mt-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-mt-option-index');
      var active = group.querySelector('.mt-active, .mt-swatch.mt-active');
      if (active) selections[idx] = active.getAttribute('data-mt-option-value');
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selections).every(function (idx) {
          return opts[Number(idx)] === selections[idx];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) { addText.textContent = form.getAttribute('data-texto-agotado') || 'No disponible'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = mtFormatMoney(variant.price, moneyFormat);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = mtFormatMoney(variant.compare_at_price, moneyFormat);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available
        ? (window.mtTextoBoton || 'Añadir al carrito')
        : (window.mtTextoAgotado || 'Agotado');
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.querySelector('[data-mt-producto-img]');
        if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
      }
    }

    form.querySelectorAll('[data-mt-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-mt-option-index');
      group.querySelectorAll('[data-mt-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-mt-option-value]').forEach(function (b) { b.classList.remove('mt-active'); });
          btn.classList.add('mt-active');
          selections[idx] = btn.getAttribute('data-mt-option-value');
          var label = document.querySelector('[data-mt-opcion-actual-' + idx + ']');
          if (label) label.textContent = selections[idx];
          applyVariant(findVariant());
        });
      });
    });

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-mt-thumb]'));

    function selectThumb(thumb) {
      if (!thumb) return;
      thumbs.forEach(function (t) { t.classList.remove('mt-active'); });
      thumb.classList.add('mt-active');
      var mainImg = document.querySelector('[data-mt-producto-img]');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb); });
    });

    /* Deslizar la imagen principal en celular (touch) para cambiar de foto,
       igual que el swipe nativo de una galería — antes solo se podía
       cambiar tocando las miniaturas de abajo. */
    var mainMedia = document.querySelector('[data-mt-producto-media]');
    if (mainMedia && thumbs.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      mainMedia.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      mainMedia.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains('mt-active'); });
        if (activeIndex === -1) activeIndex = 0;
        var nextIndex = dx < 0
          ? (activeIndex + 1) % thumbs.length
          : (activeIndex - 1 + thumbs.length) % thumbs.length;
        selectThumb(thumbs[nextIndex]);
      }, { passive: true });
    }

    var qtyInput = form.querySelector('[data-mt-qty-input]');
    var qtyMinus = form.querySelector('[data-mt-qty-minus]');
    var qtyPlus = form.querySelector('[data-mt-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) - 1;
        qtyInput.value = Math.max(1, val);
      });
      qtyPlus.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = isNaN(val) || val < 1 ? 1 : val;
      });
    }
  }

  /* -----------------------------------------------------------------------
     TARJETA DESTACADA (portada) — los swatches de color cambian la foto
     mostrada ahí mismo, sin entrar al producto. Cada botón trae su imagen
     en data-image (la foto asignada a esa variante en Shopify); si un
     color todavía no tiene foto asignada, el botón no hace nada al hacer
     clic (mejor eso a que se vea una imagen equivocada).
     --------------------------------------------------------------------- */
  function initColeccionSwatches() {
    document.querySelectorAll('[data-mt-home-swatch-root]').forEach(function (root) {
      var swatches = root.querySelectorAll('[data-mt-home-swatch]');
      var img = root.querySelector('[data-mt-home-img]');
      var nameEl = root.querySelector('[data-mt-home-color-name]');
      var links = root.querySelectorAll('[data-mt-home-link]');
      if (!swatches.length) return;

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var image = btn.getAttribute('data-image');
          var url = btn.getAttribute('data-url');
          swatches.forEach(function (b) { b.classList.remove('mt-active'); });
          btn.classList.add('mt-active');
          if (image && img) img.src = image;
          if (nameEl) nameEl.textContent = btn.getAttribute('data-color');
          if (url) links.forEach(function (a) { a.href = url; });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    safe(initReveal, 'reveal animations');
    safe(initResenas, 'reseñas');
    safe(initProducto, 'página de producto');
    safe(initColeccionSwatches, 'swatches de la tarjeta destacada');
  });
})();
